import { render } from "./RequestQuoteView.vue?vue&type=template&id=708998d4"
import script from "./RequestQuoteView.vue?vue&type=script&lang=js"
export * from "./RequestQuoteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__